const Loader = () => {

  return (
    <div className="flex justify-center items-center h-20 w-20 mx-auto">
      <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 border-solid" />
    </div>
  );
};

export default Loader;